<template>
  <div class="modal">
    <div class="modal-content select-category-modal">
      <p class="btn" v-on:click="closeModal">x</p>
      <form>
        <input type="text" v-model="search" class="input" placeholder="Search Sale Person">
      </form>
      <div class="category-list">
        <div 
          v-for="role in roles.data" 
          v-if="search == '' || role.name.toLowerCase().startsWith(search.toLowerCase())"
          :key="role.name" 
          v-on:click="handleSubmit(role.name)"
          class="category btn"
        >
          <p style="text-transform: capitalize;">{{role.name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['closeModal', 'onSubmit'],
  data() {
    return {
      search: ''
    }
  },
  methods: {
    handleSubmit(role) {
      this.onSubmit(role)
      this.closeModal()
    }
  },
  computed: {
    roles() {
      return this.$store.state.userRoleModule.roles
    }
  }
}
</script>

<style>

</style>